import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Star } from "lucide-react";
import { api, cardImageUrl, publicImageUrl } from "@/lib/api";
import { RatingModalCard } from "@/components/RatingModal";

export default function Calificaciones() {
  const [list, setList] = useState(null);
  const [open, setOpen] = useState(null);
  const load = () => api.get("/ratings/pending").then((r) => setList(r.data || [])).catch(() => setList([]));
  useEffect(() => { load(); }, []);

  return (
    <div className="max-w-2xl mx-auto px-5 py-10" data-testid="ratings-page">
      <h1 className="font-display text-4xl sm:text-5xl mb-2">Calificaciones pendientes</h1>
      <p className="text-sm text-neutral-400 mb-6">Tu nota y la que te dieron solo se muestran en el perfil cuando ambos califican. Tienes 14 días desde el cierre del pedido.</p>
      {list === null && <p className="text-neutral-500 text-sm">Cargando…</p>}
      {list?.length === 0 && <p className="text-neutral-400 text-sm" data-testid="ratings-empty">No tienes calificaciones pendientes.</p>}
      <div className="space-y-3">
        {list?.map((p) => (
          <div key={`${p.order_id}-${p.role}`} className="flex items-center gap-3 bg-[#111] border border-[#262626] rounded-md p-4" data-testid={`rating-pending-${p.order_id}`}>
            {(p.card_image_url || p.photo) && <img src={p.card_image_url ? cardImageUrl(p.card_image_url) : publicImageUrl(p.photo)} alt="" className="w-12 h-16 object-cover rounded" />}
            <div className="flex-1 min-w-0 text-sm">
              <div className="text-white truncate">{p.card_name || "—"}{p.is_auction && <span className="ml-1.5 text-[10px] uppercase text-amber-300">Subasta</span>}</div>
              <div className="text-neutral-500 text-xs">{p.role === "buyer" ? "Vendedor" : "Comprador"}: <b className="text-neutral-300">{p.other_name || "—"}</b></div>
              <Link to={`/order/${p.order_id}`} state={{ noRatingModal: true }} className="text-xs text-neutral-500 hover:underline">Ver pedido</Link>
            </div>
            <button onClick={() => setOpen(p)} className="inline-flex items-center gap-1.5 h-10 px-4 rounded-md bg-[#EF4444] hover:bg-[#DC2626] text-white text-sm font-semibold transition-colors" data-testid={`rating-open-${p.order_id}`}>
              <Star size={14} /> Calificar
            </button>
          </div>
        ))}
      </div>
      {open && <RatingModalCard key={`${open.order_id}-${open.role}`} pending={open} onDismiss={() => setOpen(null)} onSubmitted={() => { setOpen(null); load(); }} />}
    </div>
  );
}
